import { createContext } from 'react';
import { StandardLifeCookie } from '~/types';

export interface AnalyticsContextProps {
    pushEvent: (data: Record<string, string>) => void;
    standardLifeCookie: StandardLifeCookie;
}

export const AnalyticsContext = createContext<AnalyticsContextProps | undefined>(undefined);
